import { useQuery } from '@tanstack/react-query';
import type { components } from '@adiox/api';
import { useApi, useSession } from '@adiox/ui';

export type AccountLabel = components['schemas']['AccountLabel'];

/** What each of the user's accounts is (Challenge phase, Funded, Demo or Live), for the switcher and the user menu. */
export function useAccountLabels(): Map<number, AccountLabel> {
  const api = useApi();
  const accounts = useSession().user?.accounts ?? [];
  const labels = useQuery({
    queryKey: ['account-labels', [...accounts].sort().join(',')],
    enabled: accounts.length > 0,
    staleTime: 60_000,
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/me/accounts');
      return data ?? [];
    },
  }).data;
  return new Map((labels ?? []).map((l) => [l.login, l]));
}

/** "#100001 · Phase 1", or just "#100001" before the labels arrive. */
export const accountName = (login: number, label: AccountLabel | undefined) =>
  label ? `#${login} · ${label.label}` : `#${login}`;
